import { Component,
         OnInit } from '@angular/core'

@Component({
  selector: 'ss-path-not-found',
  templateUrl: 'path-not-found.component.html',
  styleUrls: ['path-not-found.component.scss']
})

export class PathNotFoundComponent implements OnInit {
  model: any = {}
  loading = false

  constructor(
  ) { }

  ngOnInit() {}
}
